import { Visit } from '../visits/visit';
import { Allergy } from '../allergies/allergy';
import { History } from '../histories/history';
import { Medication } from '../medications/medication';
import { Hospitalization } from '../hospitalizations/hospitalization';
import { Condition } from '../conditions/condition';

const camelcaseKeysDeep = require('camelcase-keys-deep');

export class MedicalHistory {
  patient: string;
  drinkAlcohol: string;
  useTobacco: string;
  useDrugs: string;
  visitHistory: any;
  patientMedications: any;
  conditions: any;
  hospitalization: any;
  allergies: any;
  familyHistory: any;

  constructor(data: any) {
    data = camelcaseKeysDeep(data);

    this.patient = data.patient;
    this.drinkAlcohol = data.drinkAlcohol;
    this.useTobacco = data.useTobacco;
    this.useDrugs = data.useDrugs;
    if (data.visitHistory && typeof (data.visitHistory) === 'object') {
      this.visitHistory = data.visitHistory.map(v => new Visit(v));
    } else {
      this.visitHistory = [];
    }
    if (data.latestAllergies && typeof (data.latestAllergies) === 'object') {
      this.allergies = data.latestAllergies.map(a => new Allergy(a));
    } else {
      this.allergies = [];
    }
    if (data.latestMedications && typeof (data.latestMedications) === 'object') {
      this.patientMedications = data.latestMedications.map(m => new Medication(m));
    } else {
      this.patientMedications = [];
    }
    if (data.latestFamilyHistory && typeof (data.latestFamilyHistory) === 'object') {
      this.familyHistory = data.latestFamilyHistory.map(h => new History(h));
    } else {
      this.familyHistory = [];
    }
    if (data.latestHospitalization && typeof (data.latestHospitalization) === 'object') {
      this.hospitalization = data.latestHospitalization.map(h => new Hospitalization(h));
    } else {
      this.hospitalization = [];
    }
    if (data.latestPatientConditions && typeof (data.latestPatientConditions) === 'object') {
      this.conditions = data.latestPatientConditions.map(c => new Condition(c));
    } else {
      this.conditions = [];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/patients/medical-history.ts